module.exports = __webpack_public_path__ + "img/score.027d80a6.png";